<div class="page-container" [class.loading]="isLoading">
    <app-header title="{{ 'employees.myTeam.myTeam' | translate }}" [menuService]="employeeModuleMenuService">
    </app-header>

    <app-table [table]="table">
        <div class="empty">
            <img class="empty-icon" src="/assets/illustrations/sofa.png" />
            <h2 class="ui centered header">{{ 'employees.myTeam.noTeamMembersFound' | translate }}</h2>
        </div>
    </app-table>
</div>
